import React from "react";
import classNames from "classnames";
import styles from "./SubcategoriesScreen.module.scss";
import { useTranslation } from "react-i18next";
import { LayoutSmContainer } from "./LayoutSm";
import { ItemButton } from "@/elements-react/menu/ItemButton";
import { useLayoutFragment } from "@/elements-react/menu/LayoutFragment.tsx";

type MenuItem = {
  key: string;
  name: string;
  url: string;
};

type ParentCategory = {
  name: string;
};

type SubcategoriesScreenProps = {
  items: MenuItem[];
  parentCategory: ParentCategory;
  onToCategory?: (key: string) => void;
  onBack?: () => void;
};

const SubcategoriesScreen: React.FC<SubcategoriesScreenProps> = ({ items, parentCategory, onToCategory, onBack }) => {
  const { t } = useTranslation();

  const handleCategoryClick = (key: string) => {
    onToCategory?.(key);
  };

  const handleBackClick = () => {
    onBack?.();
  };

  const renderSubCategories = () =>
    useLayoutFragment((layout) =>
      layout.renderSection({
        segment: "subcategories",
        content: () => (
          <div className={styles.items}>
            {items.map((item) => (
              <ItemButton key={item.key} action="link" href={item.url} title={item.name} onClick={() => handleCategoryClick(item.key)} />
            ))}
          </div>
        ),
      }),
    );

  return (
    <div className={classNames(styles.root)}>
      {useLayoutFragment((layout) =>
        layout.renderHeadStack({
          title: parentCategory.name,
          onBack: handleBackClick,
        }),
      )}
      {renderSubCategories()}
      {useLayoutFragment((layout) => layout.renderDelimiter())}
    </div>
  );
};

export default SubcategoriesScreen;
